<template><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <path d="M18.5,8.5h-7v-7a1.5,1.5,0,0,0-3,0v7h-7a1.5,1.5,0,0,0,0,3h7v7a1.5,1.5,0,0,0,3,0v-7h7a1.5,1.5,0,0,0,0-3Z"/>
</svg></template>